import { sections } from '../../constants'

const supportedSections = [
  sections.header,
  sections.hero,
  sections.body,
  sections.experiencesIntro,
  sections.col1,
  sections.col2,
  sections.col3,
  sections.footer
]

export default supportedSections
